<script setup lang="ts">
import { computed } from 'vue';
import { useRouter, type RouteLocationRaw } from 'vue-router';
import Button from 'primevue/button';

const props = withDefaults(
    defineProps<{
        buttonIcon?: string;
        loadingIcon?: string;
        buttonShape?: string;
        buttonColor?: string;
        loading?: boolean;
        path: RouteLocationRaw;
        tooltipHelper?: string | null;
        disabled?: boolean;
    }>(),
    {
        buttonIcon: 'pi pi-angle-right',
        loadingIcon: 'pi pi-spinner pi-spin',
        loading: false,
        buttonShape: 'p-button-rounded p-button-outlined ',
        buttonColor: 'p-button',
        tooltipHelper: null,
    }
);

const emit = defineEmits<{
    (e: 'navigate'): void;
}>();

const router = useRouter();

function onClick() {
    router.push(props.path);

    emit('navigate');
}

const icon = computed(() =>
    props.loading ? props.loadingIcon : props.buttonIcon
);
</script>

<template>
    <Button
        v-tooltip.bottom="tooltipHelper ?? undefined"
        :class="[buttonShape, buttonColor]"
        :icon="icon"
        :disabled="disabled"
        @click="onClick"
    />
</template>
